// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2958":"b9d8a1dd","5593":"e46bbeb6","9831":"b9d8a1dd"}[chunkId] + ".chunk.css";
};